import React, { useMemo } from 'react';
import Localize from 'react-intl-universal';

import { defaultThumbnail } from '@common/Constants';
import { useGlobalContext } from '@hooks/Context/GlobalContext';
import withDeviceType from '@hooks/Viewport/withDeviceType';

import EventGridItem from './EventGridItem/EventGridItem';
import EventListItem from './EventListItem/EventListItem';

const EventItem = ({ view, event, itemConfig, onItemClick }) => {
  const eventTypeName = event?.type?.value;
  const image = event?.thumbnailImage;
  const [contextData] = useGlobalContext();

  const memoizedImageSource = useMemo(() => {
    if (image && image !== defaultThumbnail.name) {
      itemConfig.content.notDefaultImg = true;
      return `data:image/jpeg;base64,${image}`;
    } else {
      itemConfig.content.notDefaultImg = false;

      try {
        return new URL(`../../assets/Images/${itemConfig.content.img}`, import.meta.url).href;
      } catch (e) {
        console.warn('Image not found:', itemConfig.content.img);
        return null;
      }
    }
  }, [image, defaultThumbnail.name, itemConfig.content.img]);

  const showMaxSeats = (availableSeats, maxParticipants) =>
    availableSeats === 0
      ? Localize.get('Catalog.fullybooked')
      : contextData?.isSeatsNumber
        ? `${availableSeats}/${maxParticipants}`
        : Localize.get('Catalog.seatsAvailable');

  return (
    <>
      {
        {
          ['grid']: (
            <EventGridItem
              event={event}
              config={itemConfig}
              onItemClick={onItemClick}
              memoizedImageSource={memoizedImageSource}
              label={eventTypeName}
              showMaxSeats={showMaxSeats}
            />
          ),

          ['list']: (
            <EventListItem
              view={view}
              event={event}
              itemConfig={itemConfig}
              onItemClick={onItemClick}
              memoizedImageSource={memoizedImageSource}
              label={eventTypeName}
              showMaxSeats={showMaxSeats}
            />
          )
        }[view]
      }
    </>
  );
};

export default withDeviceType(EventItem);
